import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { Text } from 'apps/auth/components/common/Text/Text';
import { getCurrencyIcon } from 'apps/auth/helpers/utils';

const AccountPlashka = (props) => {
    const {
        account: {
            pocketCurrency: { code },
            balance,
            id,
        },
    } = props;

    return (
        <Panel isHoverable negativeMargin justify="between" onClick={props.onClickHandler.bind(null, id)}>
            <Row flex align="center">
                <DiskBadge src={getCurrencyIcon(code.toLowerCase())} alt={code.toLowerCase()} onError={props.onError} />
                <Text color="primary">{code}</Text>
            </Row>
            <Text color="secondary">
                {`${balance} `}
                <Text smallCaps leftSpacer color="secondary">
                    {code.toLowerCase()}
                </Text>
            </Text>
        </Panel>
    );
};
export default AccountPlashka;
